app.bind('default', function (context) {
    const $map = $('[js-map-contact]', context)
    function init(map) {
        const iconImageHref = $(map).data('url-map')
        const myMap = new ymaps.Map(map, {
            center: $(map).data('coords'),
            zoom: 15,
            controls: []
        })

        myMap.behaviors.disable('scrollZoom')

        let myPlacemark = new ymaps.Placemark($(map).data('coords'), {
            hintContent: '',
            balloonContent: ''
        }, {
            iconImageHref,
            iconImageSize: [45, 62]
        })
        myMap.geoObjects.add(myPlacemark)
    }

    if ($map.length) {
        ymaps.ready(() => $map.each((index, map) => init(map)))

    }
})
